import { Tooltip } from 'antd'
import React, { useState } from 'react'
import { ProjectImpact } from 'src/core/models'
import styles from './ProjectImpactCard.module.scss'

const ProjectImpactCard: React.FC<{ impact: ProjectImpact }> = ({ impact }) => {
  const [isFlipped, setIsFlipped] = useState<boolean>(false)

  const backGround = { backgroundImage: `url(${impact?.image})` }

  const shouldShowTooltip = impact.description.length >= 100

  return (
    <div
      className={`${styles.card} ${isFlipped ? styles.flipped : ''}`}
      style={backGround}
      onClick={() => setIsFlipped(!isFlipped)}
    >
      <div className={`${styles.content} ${isFlipped ? styles.contentBehind : styles.contentFront}`}>
        {!isFlipped ? (
          <div className={styles.nameContent}>{impact.name}</div>
        ) : (
          <>
            {shouldShowTooltip ? (
              <Tooltip title={impact.description} color='cyan'>
                <div className={styles.impactDescription}>{impact.description}</div>
              </Tooltip>
            ) : (
              <div className={styles.impactDescription}>{impact.description}</div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default ProjectImpactCard
